export enum LocalStorageKey {
    "Session" = "session",
}
